import type { TrendRange } from '../types';

const RANGES: { value: TrendRange; label: string }[] = [
  { value: '7d', label: '7 Days' },
  { value: '30d', label: '30 Days' },
  { value: '90d', label: '90 Days' },
  { value: 'all', label: 'All Time' },
];

type TimeRangeToggleProps = {
  value: TrendRange;
  onChange: (range: TrendRange) => void;
};

export default function TimeRangeToggle({
  value,
  onChange,
}: TimeRangeToggleProps) {
  return (
    <div className="inline-flex rounded-lg border border-neutral-200 dark:border-neutral-700 overflow-hidden">
      {RANGES.map((range, index) => {
        const isActive = value === range.value;
        const isFirst = index === 0;
        const isLast = index === RANGES.length - 1;
        return (
          <button
            key={range.value}
            type="button"
            onClick={() => onChange(range.value)}
            className={[
              'px-4 py-2 text-sm font-medium transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-primary',
              isFirst
                ? ''
                : 'border-l border-neutral-200 dark:border-neutral-700',
              isActive
                ? 'bg-primary-600 text-white'
                : 'bg-white dark:bg-neutral-800 text-neutral-600 dark:text-neutral-300 hover:bg-neutral-50 dark:hover:bg-neutral-700',
              isFirst ? 'rounded-l-lg' : '',
              isLast ? 'rounded-r-lg' : '',
            ]
              .filter(Boolean)
              .join(' ')}
            aria-pressed={isActive}
          >
            {range.label}
          </button>
        );
      })}
    </div>
  );
}
